import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { Image } from '~/elements/Image/Image'
import { useRouter } from 'next/router'
import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button'
import { SortOption } from '@constructor-io/constructorio-client-javascript'

type Props = {
  options?: SortOption[]
  handleSortChange: (option: SortOption) => Promise<void>
}

export const CioSortSelect = ({ options, handleSortChange }: Props) => {
  const { t } = useTranslation()
  const router = useRouter()

  const selectedOption = router?.query?.sort

  return (
    <Menu>
      {({ isExpanded }) => (
        <>
          <MenuButton className="flex flex-nowrap items-center">
            <span className="mr-3 text-p font-extralight text-primary-black">{t('Sort')}</span>
            <span aria-hidden="true">
              <div className="h-18px w-[18px] rounded-full bg-sg-grey p-0.5">
                <Image
                  src="/images/Icons/chevron-down.svg"
                  width={24}
                  height={24}
                  placeholder="empty"
                  className={clsx('transition', isExpanded ? 'rotate-180' : '')}
                  alt="chevron-icon"
                />
              </div>
            </span>
          </MenuButton>
          <MenuList className="relative border-grey-border p-0" style={{ zIndex: 999999 }}>
            {options?.map((option) => (
              <MenuItem key={option.display_name} onSelect={() => handleSortChange(option)}>
                <span
                  className={clsx(
                    selectedOption === option.sort_by
                      ? 'font-medium text-primary-black'
                      : 'text-grey-dark',
                  )}
                >
                  {option.display_name}
                </span>
              </MenuItem>
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  )
}
